import React from 'react'
import styled, { css, keyframes } from 'styled-components'
import { themeVariables } from 'themes/themeVariables'

const animation = keyframes`
    0% {
        transform: translateX(-100%) translateZ(0);
    }

    45% {
        transform: translateX(0%) translateZ(0);
    }

    55% {
        transform: translateX(0%) translateZ(0);
    }

    100% {
        transform: translateX(100%) translateZ(0);
    }
`

const HorizontalLoadingIndicatorRoot = styled.div<{ $loading?: boolean }>`
    height: 0;
    opacity: 0;
    transition: opacity 0.3s ease-out;
    will-change: opacity;
    transform: translateY(-1px);

    ${({ $loading = false }) =>
        $loading &&
        css`
            opacity: 1;
        `}

    div {
        height: 1px;
        position: relative;
        overflow: hidden;
    }

    div:after {
        animation: 2s infinite ${animation};
        background: ${themeVariables.colors.info};
    }

    div:after,
    div:before {
        content: '';
        display: block;
        height: 100%;
        position: absolute;
        width: 100%;
    }
`

interface HorizontalLoadingIndicatorProps {
    loading?: boolean
    className?: string
}

export function HorizontalLoadingIndicator({
    loading = false,
    ...props
}: HorizontalLoadingIndicatorProps) {
    return (
        <HorizontalLoadingIndicatorRoot {...props} $loading={loading}>
            <div />
        </HorizontalLoadingIndicatorRoot>
    )
}
